import React, { Component } from "react"
import "./SocTempFilter.css"
import { connect } from 'react-redux';
import actions from '../../store/actions';
import Dom from '../../helpers/Dom';
import { color } from "d3-color";
import { utcMilliseconds } from "d3";
import { getReportDownload } from "../ReportWindow/schema/EVReport/EVInsight/components/JSONCSV";
import moment from "moment";
import cell_temp from '../../../src/assets/svg/cell3.svg';
import bat_temp from '../../../src/assets/svg/battery-3.svg';
import soc from '../../../src/assets/svg/soc.svg';
import {isBlueSmart} from '../../helpers/helperFunctions'

class SocTempFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vehicleList:[],
            showPopup: false,
            celltab: false,
            battab: false,
            soctab: false,
            chargetab: false,
        }

        this.closePopup = () =>{
            this.setState({
                showPopup:false,
            })
        }

        window.closeBuckets = () => {
            this.setState({
                celltab: false,
                battab: false,
                soctab: false,
                chargetab: false,
            })
        }
        this.applyStatFilter = (item) => {
            let vehicleList=[]
            let key = this.props.statsFilter.key
            this.setState({
                vehicleList:[],
                showPopup: true,
                socCategory: item.key

            })
            if (item.key === "never-comm-gps") {
                this.setState({
                    ncGps: true,
                    newbucket: true,
                    locZero: false
                })
            }
            else this.setState({
                newbucket: false
            })
            if (item.key === "location-zero") {
                this.setState({
                    newbucket: true,
                    locZero: true,
                    ncGps: false,

                })
            }
            if(key != null){
                Object.values(props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key) && v.filters.includes(key)) {
                         vehicleList.push(v)
                    }})
                    this.setState({
                        vehicleList:  vehicleList
                    })
            }else{
                Object.values(props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key)) {
                        vehicleList.push(v)
                    }})
                    this.setState({
                        vehicleList:  vehicleList
                    })            
                
            }
            // this.props.dispatch({
            //     type: actions.TOGGLE_STATS_FILTER,
            //     data: item,
            // })
            // this.props.dispatch({
            //     type: actions.TOGGLE_LEFT_TREE,
            //     data: this.props.leftTree ? 0 : 1,
            //   });
              this.props.dispatch({
                type: actions.SOC_SORTED,
                data: vehicleList
              });
              this.props.dispatch({
                type: actions.TOGGLE_LEFT_TREE,
                data: 4
              });
              this.props.dispatch({
                type: actions.LOCK_BUTTON,
                data: {
                    key : item.key,
                    clicked: false
                }
              });
              
        };

        this.getStatsIcon = item => {
            switch (item.iconType) {
                case 'svg':
                    return <object className={'-' + item.color} data={item.icon}></object>;
                    break;

                case 'text':
                    return <span className={"hc-textIcon -" + item.color}>{item.icon}</span>;
                    break;

                default:
                    return <span className={'hc-classIcon ' + item.icon + ' -' + item.color}></span>;
            }
        };

        this.getStats = (item) => {
            if(this.props.searchResult != null && this.props.searchString !== ""){
                return Object.values(this.props.searchResult).filter(v => {
                    if(v.filters.includes(item.key)){
                        return true
                    }
                }).length
            }
            const checkpath = window.localStorage.getItem("checkpath");
            if(checkpath && this.props.statsFilter) {
                const groups = JSON.parse(checkpath);
                const gpaths = groups.map(g => g.path);
                let key = this.props.statsFilter.key
                return Object.values(this.props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key) && v.filters.includes(key)) {
                        const gs = v.groups.map(g => g.path)
                        for(let g of gpaths) {
                            if(gs.includes(g)) return true;
                        }
                    }
                }).length
            } 
            if(this.props.statsFilter && this.props.statsFilter.key){
                let key = this.props.statsFilter.key
                return Object.values(this.props.vehicleMap).filter(v => {
                    if(v.filters.includes(item.key) && v.filters.includes(key)){
                        return true
                    }
                }).length

            }
            // new: change stats count if group selected/unselected
            // TODO: move to backend
           
            return this.props.stats && this.props.stats[item.key] != null ? this.props.stats[item.key] : 0;
        };
    }


    getStatsConfig = () => {
        let stats = [];
        for (let idx in this.props.statsConfig) {
            if (!this.props.statsConfig[idx].parent) {
                this.props.statsConfig[idx].children = [];
                stats.push(this.props.statsConfig[idx])
            }
        }

        for (let idx in this.props.statsConfig) {
            if (this.props.statsConfig[idx].parent) {
                for (let jdx in stats) {
                    if (stats[jdx].key === this.props.statsConfig[idx].parent) {
                        stats[jdx].children.push(this.props.statsConfig[idx]);
                    }
                }
            }
        }
        return stats;
    }

    
    isItemActive = key => {
        if (!this.props.statsFilter)
            return false;
            // console.log("key",this.props.statsFilter.key,this.state.socCategory)

        // if (this.props.statsFilter.key === key) {
        //     return true;
        // }
        // let config = this.getStatsConfig();
        // for (let idx in config) {
        //     if (config[idx].key === key) {
        //         for (let jdx in config[idx].children) {
        //             if (config[idx].children[jdx].key === this.props.statsFilter.key) {
        //                 return true;
        //             }
        //         }
        //     }
        // }
        // if(this.props.statsFilter.key !== this.state.socCategory) return false
        if(this.state.socCategory === key ) return true
        else return false
    }
    componentWillReceiveProps(props){
        if(this.props.statsFilter && props.statsFilter.key !== this.props.statsFilter.key) {
            this.setState({socCategory : "",
                vehicleList : []
            },() => {
                this.props.dispatch({
                    type: actions.SOC_SORTED,
                    data: this.state.vehicleList
                  });
                  this.props.dispatch({
                    type: actions.TOGGLE_LEFT_TREE,
                    data: 0
                  });
            })
        }
    }

    render() {
        return (
        <div>
            <div className="SocFilter">
                {/* <div className="bucket">
                    <div className="bucketicon"><i className="fas fa-car-battery"></i></div>
                    <div className="switch">
                        {
                            this.getStatsConfig().map((item, index) => {
                                if(item.type == "soc"){
                                    return (
                                        <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                            <div style={{color:item.clr}}>{item.name}</div>
                                            <div>{this.getStats(item)}</div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>
                <div className="bucket">
                    <div className="bucketicon"><i className="fas fa-temperature-high"></i></div>
                    <div className="switch">
                        {
                            this.getStatsConfig().map((item, index) => {
                                if(item.type == "temp"){
                                    return (
                                        <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                            <div style={{color:item.clr}}>{item.name}</div>
                                            <div>{this.getStats(item)}</div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}
                {/* <div className="bucket">
                    <div style={{color:"rgb(91, 204, 91)"}} className="bucketicon"><i className="fas fa-charging-station"></i></div>
                    <div className="switch">
                        {
                            this.getStatsConfig().map((item, index) => {
                                if(item.type == "cc"){
                                    return (
                                        <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                            <div style={{color:"grey"}}>Charging</div>
                                            <div>{this.getStats(item)}</div>
                                            <div className="last-updated">At {window.charging_updatedat}</div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}
               
                {/* {this.state.showPopup &&
                <SOCListPopup data = {this.state.vehicleList} closePopup={this.closePopup} socCategory = {this.state.socCategory}/>} */}
            </div>
            {this.props && this.props.userInfo && !this.props.userInfo.SELF.hide_all_buckets ?<div className="AllEvBucket">
            {this.props.userInfo.SELF.enable_charging_bucket ? (<div className={this.state.chargetab ? "newChargeSwitch_slide" : "newChargeSwitch"}>
            <div className="bucket-name"><span>Charging</span></div>
                {
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "cc"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:"grey"}}>Charging</div>
                                    <div>{this.getStats(item)}</div>
                                    <div className="last-updated">At {window.charging_updatedat}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>) : null}
            {this.props.userInfo.SELF.enable_charging_bucket ? (<div className="newChargingBucket" onClick={() => {
                this.setState({chargetab: !this.state.chargetab, battab:false, celltab:false, soctab:false});
                if(isBlueSmart(this.props)) window.closeNewbuckets()}}>
                <div className="bucketicon" >
                <i className="fas fa-charging-station"></i>
                </div>
            </div>) : null}
             <div className={this.state.celltab ? "newswitch_slide" : "newswitch"}>
             <div className="bucket-name"><span>Cell Temp</span></div>
                {
                    
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "celltemp"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:item.clr}}>{item.name}</div>
                                    <div>{this.getStats(item)}</div>
                                </div>
                            )
                        }
                    })
                }
            </div> 
            <div className="newbucket" onClick={() => {
                this.setState({celltab: !this.state.celltab,battab:false, soctab:false, chargetab: false}); 
                if(isBlueSmart(this.props)){
                    window.closeNewbuckets()
                } }}>
                <div className="bucketicon" >
                    <img src={cell_temp}/>
                </div>
            </div>
            <div className={this.state.battab ? "newTempSwitch_slide" : "newTempSwitch"}>
            <div className="bucket-name"><span>Battery Temp</span></div>
                {
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "temp"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:item.clr}}>{item.name}</div>
                                    <div>{this.getStats(item)}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
            <div className="newTempBucket" onClick={() => {
                this.setState({battab: !this.state.battab,soctab:false, celltab:false, chargetab: false}); 
                
                if(isBlueSmart(this.props))window.closeNewbuckets() }}>
                <div className="bucketicon" >
                    <img src={bat_temp}/>
                </div>
            </div>
            <div className={this.state.soctab ? "newSocSwitch_slide" : "newSocSwitch"}>
            <div className="bucket-name"><span>SoC</span></div>
                {
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "soc"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:item.clr}}>{item.name}</div>
                                    <div>{this.getStats(item)}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
            <div className="newSocBucket" onClick={() => {
                this.setState({soctab: !this.state.soctab, battab:false, celltab:false, chargetab: false});
                if(isBlueSmart(this.props)) window.closeNewbuckets()}}>
                <div className="bucketicon" >
                    <img src={soc}/>
                </div>
            </div>
            {this.props.userInfo.SELF.enable_charging_bucket ? (<div className={this.state.chargetab ? "newChargeSwitch_slide" : "newChargeSwitch"}>
            <div className="bucket-name"><span>Charging</span></div>
                {
                    this.getStatsConfig().map((item, index) => {
                        if(item.type == "cc"){
                            return (
                                <div key={index} className={Dom.Class({ 'active': this.isItemActive(item.key) }, "switchbtn")} onClick={() => this.applyStatFilter(item)}>
                                    <div style={{color:"grey"}}>Charging</div>
                                    <div>{this.getStats(item)}</div>
                                    <div className="last-updated">At {window.charging_updatedat}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>) : null}
            {this.props.userInfo.SELF.enable_charging_bucket ? (<div className="newChargingBucket" onClick={() => {
                this.setState({chargetab: !this.state.chargetab, battab:false, celltab:false, soctab:false});
                if(isBlueSmart(this.props)) window.closeNewbuckets()}}>
                <div className="bucketicon" >
                <i className="fas fa-charging-station"></i>
                </div>
            </div>) : null}
            </div> :null}
            </div>
        )
    }
}

const MapPropsToState = (state) => {
    return {
        auth: state.auth,
        stats: state.stats,
        roadStats: state.roadStats,
        reportWindow: state.reportWindow,
        statsFilter: state.statsFilter,
        gotAllBuckets: state.gotAllBuckets,
        vehicleMap: state.vehicleMap,
        userInfo: state.userInfo,
        userType: state.userType,
        multiSearchConditions: state.multiSearchConditions,
        searchResult: state.searchResult,
        searchString: state.searchString,
        groupTree: state.groupTree
    }
};

 export default connect(MapPropsToState)(SocTempFilter);

class SOCListPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: [],
            locZeroData: [],
            searchStr: "",
            items: [],
        }

        this.vehicleData = [];
        this.data = [];
        this.finalFilterData = {};
        this.gpsTempData = [];
        this.locZeroTemp = [];
        this.locZeroData = [];
        this.searching = false;

        this.searchVehicle = (e) => {
            let str = e.target.value.toUpperCase().trim();
            if (str.length != 0) {
                this.searching = true;
            } else {
                this.searching = false;
            }
            if (this.props.data) {
                let newArray = this.props.data.filter((d) => {
                    let searchValue = d.vehicleno;
                    if(searchValue.indexOf(str) !== -1)return searchValue.indexOf(str) !== -1;
                    
                })
                this.setState({
                    items: newArray,
                })
            }
        }

        this.keylistener = (e) => {
            if (e.keyCode === 27) this.props.closePopup()
        }
        this.handleCheck = (e) => {
            if(this.refs.soccontainer && !this.refs.soccontainer.contains(e.target)){ 
                this.closeSearch()
            }
        }
            
        this.closeSearch = () => {
            this.props.closePopup()
        }

    }
    renderHead() {
        if (this.props.data) {
            let head1 = [
                { key: 'vehicleno', heading: 'Vehicle No', width: 110 },
            ]
            return head1
        }
    }

    componentDidMount() {
        
        window.addEventListener("keydown", this.keylistener);
        window.addEventListener('mousedown', this.handleCheck)
    }

    componentWillReceiveProps(props) {
        window.addEventListener("keydown", this.keylistener);
        window.addEventListener('mousedown', this.handleCheck)
    }

    render() {
        return (
            <div className={"socList-container"} ref = "soccontainer">
                <div className="soc-search">
                    <input placeholder="Search" ref="searchVehicles" onChange={this.searchVehicle} ></input>
                    <div className="searchClose" onClick={this.closeSearch}> x </div>
                </div>
                <div className="soc-tableContainer" >
                    <table>
                        <thead>
                                {
                                    this.renderHead().map((head, index) => {
                                        return (
                                            <tr>
                                            <th key={index} style={{ width: head.width }}>{head.heading} </th>
                                           <th> <i
              onClick={() =>
                getReportDownload(
                  this.props.data,
                  this.renderHead(),
                  this.props.socCategory+"/"+(moment(Date.now()).format('l h:mm:ss A '))
                )
              }
              className="fa fa-download"
            ></i></th>
                                            </tr>
                                        )
                                    }

                                    )
                                }
                        </thead>
                        <tbody>
                            {
                                this.props.data && !this.searching ? (this.props.data.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                this.renderHead().map((head, index2) => {
                                                    return (
                                                        <td key={index2} style={{ width: head.width }}>
                                                            {item[head.key]}
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })) : null
                            }
                            {
                                this.state.items && this.searching ? (this.state.items.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                this.renderHead().map((head, index2) => {
                                                    return (
                                                        <td key={index2} style={{ width: head.width }}>
                                                            {item[head.key]}
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })) : null
                            }

                        </tbody>
                    </table>
                    {
                        this.props.data.length === 0 ? (
                            <div className="noData"> NO DATA</div>
                        ) : null
                    }
                    {
                       this.searching && this.state.items.length === 0 && this.props.data ? (
                            <div className="noData"> NO DATA</div>
                        ) : null
                    }
                </div>
            </div>
        )
    }

}